"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicySteps = exports.StepInformation = exports.eAnnualProductRegionGroup = exports.eAnnualCargoSteps = exports.ePolicyRegion = exports.ePolicyType = exports.ePolicyStatus = void 0;
const policy_class_1 = __importDefault(require("./policy.class"));
var ePolicyStatus;
(function (ePolicyStatus) {
    ePolicyStatus["DRAFT"] = "draft";
    ePolicyStatus["UW_REVIEW"] = "uw_review";
    ePolicyStatus["PURCHASED"] = "purchased";
    ePolicyStatus["DECLINED"] = "declined";
    ePolicyStatus["QUOTED"] = "quoted";
    ePolicyStatus["BOUND"] = "bound";
    ePolicyStatus["REJECTED"] = "rejected";
    ePolicyStatus["REFERRAL"] = "referral";
    ePolicyStatus["CONTACT"] = "contact";
})(ePolicyStatus = exports.ePolicyStatus || (exports.ePolicyStatus = {}));
var ePolicyType;
(function (ePolicyType) {
    ePolicyType["OCEAN_CARGO"] = "ocean_cargo";
    ePolicyType["STOCK_THROUGHPUT"] = "stock_throughput";
    ePolicyType["MOTOR_TRUCK_CARGO"] = "mtc";
    ePolicyType["ORINOCO"] = "orinoco";
    ePolicyType["CONGO"] = "congo";
    ePolicyType["OCEAN_CARGO_EUROPE"] = "ocean_cargo_europe";
    ePolicyType["STOCK_THROUGHPUT_EUROPE"] = "stock_throughput_europe";
    ePolicyType["MOTOR_TRUCK_CARGO_EUROPE"] = "mtc_europe";
    ePolicyType["ORINOCO_EUROPE"] = "orinoco_europe";
    ePolicyType["CONGO_EUROPE"] = "congo_europe";
    ePolicyType["YUKON"] = "yukon";
})(ePolicyType = exports.ePolicyType || (exports.ePolicyType = {}));
var ePolicyRegion;
(function (ePolicyRegion) {
    ePolicyRegion["EUROPE"] = "europe";
    ePolicyRegion["USA"] = "usa";
})(ePolicyRegion = exports.ePolicyRegion || (exports.ePolicyRegion = {}));
var eAnnualCargoSteps;
(function (eAnnualCargoSteps) {
    eAnnualCargoSteps["COVERAGE"] = "coverage";
    eAnnualCargoSteps["EXPOSURES"] = "exposures";
    eAnnualCargoSteps["LOSSES"] = "losses";
    eAnnualCargoSteps["WAREHOUSE"] = "warehouse";
    eAnnualCargoSteps["REVIEW"] = "review";
    eAnnualCargoSteps["MTC"] = "mtc";
})(eAnnualCargoSteps = exports.eAnnualCargoSteps || (exports.eAnnualCargoSteps = {}));
var eAnnualProductRegionGroup;
(function (eAnnualProductRegionGroup) {
    eAnnualProductRegionGroup["USA"] = "USA";
    eAnnualProductRegionGroup["EUROPE"] = "EUROPE";
})(eAnnualProductRegionGroup = exports.eAnnualProductRegionGroup || (exports.eAnnualProductRegionGroup = {}));
class StepInformation {
    constructor(data) {
        this.valid = data.valid;
        this.errors = data.errors;
    }
    static fromObj(data) {
        return new StepInformation({
            valid: data.valid || false,
            errors: data.errors || []
        });
    }
}
exports.StepInformation = StepInformation;
class PolicySteps {
    constructor(data) {
        this.coverage = data.coverage;
        this.exposures = data.exposures;
        this.losses = data.losses;
        this.warehouse = data.warehouse;
    }
    static fromObj(data) {
        if (!data) {
            return PolicySteps.empty();
        }
        return new PolicySteps(data);
    }
    static empty() {
        return new PolicySteps({
            coverage: StepInformation.fromObj({ valid: true }),
            exposures: StepInformation.fromObj({ valid: false }),
            losses: StepInformation.fromObj({ valid: false }),
            warehouse: StepInformation.fromObj({ valid: false })
        });
    }
}
exports.PolicySteps = PolicySteps;
exports.default = policy_class_1.default;
//# sourceMappingURL=index.js.map